import * as _ from 'underscore'
import { DataProvider } from "../helpers"

import { OpOperatorGroup } from "../models/core/op-operator-group"
import { ColumnInfo, OpValidateInfo } from "../models/custom"
import { Enums } from "../models/common"

export class DataProviderOperatorGroup {

    // #region Ctor

    constructor(private dataProvider: DataProvider) { }

    // #endregion


    // #region Public method

    public deleteOperatorGroup = (operatorGroup: OpOperatorGroup) => {
        return this.dataProvider.sendRequestWithSession('OpxDeleteOperatorGroup', { ToBeDeleted: operatorGroup.toJSON() }, null)
    }

    public getOperatorGroup = (idOperatorGroup: number) => {
        return this.dataProvider
            .sendRequestWithSession('OpxGetOperatorGroup', { IdOperatorGroup: idOperatorGroup }, 'OpxGetOperatorGroupResult')
            .then((response: any) => {
                if (response != null) {
                    const operatorGroup: OpOperatorGroup = new OpOperatorGroup(response)

                    return OpOperatorGroup
                        .loadNavigationProperties(this.dataProvider, [operatorGroup])
                        .then((operatorGroups: OpOperatorGroup[]) => _.first(operatorGroups))

                }

                return null
            })
    }

    public getOperatorGroupFilter = (columns: ColumnInfo[], pageNbr: number, pageSize: number, customWhereClause: string) => {
        return this.dataProvider.sendFilterRequestWithSession<OpOperatorGroup>(columns, pageNbr, pageSize, customWhereClause, Enums.ReferenceType.IdOperatorGroup, 'OpxOperatorGroupFilter', 'OpxOperatorGroupFilterResult')
    }

    public saveOperatorGroup = (operatorGroup: OpOperatorGroup) => {
        return this.dataProvider
            .sendRequestWithSession('OpxSaveOperatorGroup', { ToBeSaved: operatorGroup.toJSON() }, 'OpxSaveOperatorGroupResult')
            .then((response: any) => {
                if (response != null) {
                    const operatorGroup: OpOperatorGroup = new OpOperatorGroup(response)

                    return OpOperatorGroup
                        .loadNavigationProperties(this.dataProvider, [operatorGroup])
                        .then((operatorGroups: OpOperatorGroup[]) => _.first(operatorGroups))

                }

                return null
            })
    }

    public validateOperatorGroup = (operatorGroups: OpOperatorGroup[]) => {
        return this.dataProvider
            .sendRequestWithSession(
                'OpxValidateOperatorGroup',
                {
                    operatorGroups: _.map(operatorGroups, (operatorGroups: OpOperatorGroup) => operatorGroups.toJSON())
                },
                'OpxValidateOperatorGroupResult'
            )
            .then((response: any) => {
                return DataProvider.convertArrayResult(response, OpValidateInfo)
            })
    }

    // #endregion
}